import React, { useEffect } from 'react';
import './About.css';

const PHONE = '+91-8796769013';
const EMAIL = 'shristiveda284@gmail.com';
const WHATSAPP = '+918796769013';
const WA_MSG = encodeURIComponent('नमस्ते! मुझे परामर्श चाहिए।');

export default function About() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const team = [
    {
      name: 'Founder',
      role: 'Co-Founder & CEO',
      story: 'महिलाओं की स्वास्थ्य समस्याओं को करीब से देखने के बाद एक ऐसा मंच बनाने की सोची जहाँ हर महिला को सुरक्षित और गोपनीय परामर्श मिल सके।',
      avatar: 'A',
      color: '#c9963a',
    },
    {
      name: 'Co-Founder',
      role: 'Co-Founder & Head of Products',
      story: 'आयुर्वेद में गहरी रुचि और महिला स्वास्थ्य के प्रति जुनून ने Shristiveda के उत्पादों को शुद्ध और प्रभावशाली बनाने में मदद की।',
      avatar: 'S',
      color: '#2d6a4f',
    },
  ];

  const milestones = [
  { year: '2026', label: 'Shristiveda की नींव रखी', icon: '🌱' },
  { year: '2026', label: 'पहला Ayurvedic Product Launch', icon: '🌿' },
  { year: '2026', label: 'पहले 50 संतुष्ट ग्राहक', icon: '🎯' },
  { year: '2026', label: 'Online Consultation शुरू', icon: '📱' },
];

  const values = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="15" stroke="#c9963a" strokeWidth="1.5"/>
          <path d="M10 16.5L14 20.5L22 12" stroke="#c9963a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'विश्वसनीयता',
      desc: 'हम वही वादे करते हैं जो हम निभा सकें। हर ग्राहक का भरोसा हमारी सबसे बड़ी पूंजी है।',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 4C16 4 7 9 7 17C7 21.4 11.1 25 16 25C20.9 25 25 21.4 25 17C25 9 16 4 16 4Z" stroke="#2d6a4f" strokeWidth="1.5" strokeLinejoin="round"/>
          <path d="M16 12V18M13 15H19" stroke="#2d6a4f" strokeWidth="1.8" strokeLinecap="round"/>
        </svg>
      ),
      title: 'प्राकृतिकता',
      desc: '100% आयुर्वेदिक सामग्री — कोई केमिकल नहीं, कोई समझौता नहीं। प्रकृति की शक्ति, सीधे आप तक।',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect x="5" y="10" width="22" height="16" rx="3" stroke="#1a2e4a" strokeWidth="1.5"/>
          <path d="M11 10V8C11 5.8 13 4 16 4C19 4 21 5.8 21 8V10" stroke="#1a2e4a" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="16" cy="18" r="2.5" fill="#1a2e4a"/>
        </svg>
      ),
      title: 'गोपनीयता',
      desc: 'आपकी हर बात, हर जानकारी पूर्णतः सुरक्षित। हम समझते हैं कि कुछ बातें सिर्फ आपकी हैं।',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 6L17.8 12H24L18.9 15.6L20.7 21.6L16 18L11.3 21.6L13.1 15.6L8 12H14.2L16 6Z" stroke="#c9963a" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'उत्कृष्टता',
      desc: 'हर उत्पाद, हर परामर्श में हम सर्वश्रेष्ठ देने की कोशिश करते हैं — यही हमारा स्टैंडर्ड है।',
    },
  ];

  return (
    <div className="about-page">

      {/* ── HERO ── */}
      <section className="about-hero">
        <div className="about-hero-bg">
          {/* Decorative SVG circles */}
          <svg className="hero-deco deco1" width="300" height="300" viewBox="0 0 300 300" fill="none">
            <circle cx="150" cy="150" r="149" stroke="rgba(201,150,58,0.15)" strokeWidth="1"/>
            <circle cx="150" cy="150" r="110" stroke="rgba(201,150,58,0.1)" strokeWidth="1"/>
          </svg>
          <svg className="hero-deco deco2" width="200" height="200" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="99" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
          </svg>
        </div>
        <div className="container about-hero-inner">
          <div className="about-hero-text">
            <div className="about-startup-badge reveal">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="7" r="6" fill="#c9963a" opacity="0.3"/>
                <circle cx="7" cy="7" r="3" fill="#c9963a"/>
              </svg>
              Startup Story
            </div>
            <h1 className="reveal">
              एक सपने से शुरू हुई<br />
              <span className="about-title-highlight">Shristiveda की यात्रा</span>
            </h1>
            <p className="about-hero-desc reveal">
              हम एक छोटे से विचार से शुरू हुए — कि हर भारतीय महिला को आयुर्वेदिक स्वास्थ्य सलाह
              घर बैठे, बिना किसी झिझक के मिलनी चाहिए। आज वह विचार एक मिशन बन चुका है।
            </p>
            <div className="about-hero-stats reveal">
              <div className="about-stat">
                <strong>50+</strong>
                <span>संतुष्ट महिलाएं</span>
                
              </div>
              <div className="about-stat-div"/>
              <div className="about-stat">
                <strong>2026</strong>
                <span>Founded</span>
              </div>
              <div className="about-stat-div"/>
              <div className="about-stat">
                <strong>100%</strong>
                <span>आयुर्वेदिक</span>
              </div>
            </div>
          </div>
          {/* Illustration */}
          <div className="about-hero-illustration reveal">
            <svg viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="160" cy="160" r="140" fill="rgba(201,150,58,0.08)" stroke="rgba(201,150,58,0.2)" strokeWidth="1"/>
              <circle cx="160" cy="160" r="100" fill="rgba(45,106,79,0.08)" stroke="rgba(45,106,79,0.2)" strokeWidth="1"/>
              {/* Leaf */}
              <path d="M160 60 C130 90 110 130 130 160 C150 190 190 190 200 160 C210 130 190 90 160 60Z" fill="rgba(45,106,79,0.25)" stroke="#2d6a4f" strokeWidth="1.5"/>
              <path d="M160 60 L160 180" stroke="#2d6a4f" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M160 110 C148 120 138 130 135 145" stroke="#2d6a4f" strokeWidth="1" strokeLinecap="round"/>
              <path d="M160 130 C172 140 180 152 180 165" stroke="#2d6a4f" strokeWidth="1" strokeLinecap="round"/>
              {/* Woman silhouette */}
              <circle cx="160" cy="205" r="18" fill="rgba(201,150,58,0.3)" stroke="#c9963a" strokeWidth="1.5"/>
              <path d="M145 240 C145 225 155 220 160 220 C165 220 175 225 175 240" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
              {/* Stars */}
              <circle cx="100" cy="120" r="3" fill="#c9963a" opacity="0.6"/>
              <circle cx="220" cy="100" r="2" fill="#c9963a" opacity="0.5"/>
              <circle cx="90" cy="200" r="2.5" fill="#2d6a4f" opacity="0.6"/>
              <circle cx="240" cy="190" r="3" fill="#2d6a4f" opacity="0.5"/>
              {/* Ayurvedic mortar */}
              <ellipse cx="245" cy="240" rx="22" ry="10" fill="rgba(201,150,58,0.2)" stroke="#c9963a" strokeWidth="1.2"/>
              <path d="M223 240 L225 255 C225 260 235 264 245 264 C255 264 265 260 265 255 L267 240" stroke="#c9963a" strokeWidth="1.2"/>
              <path d="M255 225 L265 215" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
      </section>

      {/* ── STORY ── */}
      <section className="story-section">
        <div className="container">
          <div className="story-inner">
            <div className="story-text">
              <span className="section-label reveal">हमारी कहानी</span>
              <h2 className="section-title reveal">क्यों बनाई Shristiveda?</h2>
              <p className="story-para reveal">
                भारत में लाखों महिलाएं सफेद पानी, कमर दर्द और हार्मोनल समस्याओं से परेशान रहती हैं —
                लेकिन शर्म और जानकारी की कमी की वजह से वे चुप रह जाती हैं।
              </p>
              <p className="story-para reveal">
                हमारे founders ने अपने परिवार और आस-पास की महिलाओं में यही दर्द देखा। तब एक सवाल उठा —
                <em> "क्या हम इन महिलाओं तक आयुर्वेद की शक्ति सुरक्षित और गोपनीय तरीके से पहुंचा सकते हैं?"</em>
              </p>
              <p className="story-para reveal">
                उस एक सवाल से 2023 में Shristiveda Pvt Limited की नींव पड़ी। आज हम सैकड़ों महिलाओं
                की जिंदगी में छोटा-सा बदलाव लाने की कोशिश कर रहे हैं।
              </p>
            </div>
            <div className="story-graphic reveal">
              <svg viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="20" y="20" width="240" height="240" rx="24" fill="white" stroke="var(--border)" strokeWidth="1"/>
                {/* Quote marks */}
                <text x="36" y="75" fontSize="72" fill="rgba(201,150,58,0.15)" fontFamily="serif">"</text>
                {/* Lines of text */}
                <rect x="50" y="90" width="170" height="8" rx="4" fill="rgba(26,46,74,0.1)"/>
                <rect x="50" y="108" width="150" height="8" rx="4" fill="rgba(26,46,74,0.08)"/>
                <rect x="50" y="126" width="160" height="8" rx="4" fill="rgba(26,46,74,0.08)"/>
                <rect x="50" y="144" width="120" height="8" rx="4" fill="rgba(26,46,74,0.06)"/>
                {/* Divider */}
                <line x1="50" y1="170" x2="230" y2="170" stroke="var(--border)" strokeWidth="1"/>
                {/* Logo area */}
                <circle cx="75" cy="200" r="18" fill="rgba(201,150,58,0.12)" stroke="#c9963a" strokeWidth="1"/>
                <path d="M75 192 C71 196 69 200 71 204 C73 208 79 208 81 204 C83 200 81 196 75 192Z" fill="#c9963a" opacity="0.6"/>
                <rect x="102" y="193" width="80" height="7" rx="3.5" fill="rgba(26,46,74,0.12)"/>
                <rect x="102" y="206" width="55" height="6" rx="3" fill="rgba(26,46,74,0.07)"/>
                {/* Badge */}
                <rect x="170" y="232" width="70" height="24" rx="12" fill="rgba(45,106,79,0.1)" stroke="#2d6a4f" strokeWidth="1"/>
                <text x="205" y="248" fontSize="9" fill="#2d6a4f" textAnchor="middle" fontWeight="600">Startup 2023</text>
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* ── MISSION / VISION ── */}
      <section className="mv-section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card mission reveal">
              <div className="mv-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <circle cx="20" cy="20" r="19" stroke="#c9963a" strokeWidth="1.5"/>
                  <circle cx="20" cy="20" r="12" stroke="#c9963a" strokeWidth="1" strokeDasharray="3 2"/>
                  <circle cx="20" cy="20" r="5" fill="#c9963a"/>
                  <line x1="20" y1="1" x2="20" y2="8" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
                  <line x1="20" y1="32" x2="20" y2="39" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
                  <line x1="1" y1="20" x2="8" y2="20" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
                  <line x1="32" y1="20" x2="39" y2="20" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h3>हमारा Mission</h3>
              <p>
                हर भारतीय महिला को घर बैठे, बिना किसी झिझक के, गुणवत्तापूर्ण आयुर्वेदिक
                स्वास्थ्य मार्गदर्शन और उत्पाद उपलब्ध कराना — ताकि वे अपनी सेहत का
                सही ख्याल रख सकें।
              </p>
            </div>
            <div className="mv-card vision reveal">
              <div className="mv-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M20 8C11 8 4 16 4 20C4 24 11 32 20 32C29 32 36 24 36 20C36 16 29 8 20 8Z" stroke="#2d6a4f" strokeWidth="1.5"/>
                  <circle cx="20" cy="20" r="6" stroke="#2d6a4f" strokeWidth="1.5"/>
                  <circle cx="20" cy="20" r="2.5" fill="#2d6a4f"/>
                </svg>
              </div>
              <h3>हमारी Vision</h3>
              <p>
                भारत में महिला स्वास्थ्य के क्षेत्र में आयुर्वेद को मुख्यधारा में लाना।
                एक ऐसा भविष्य बनाना जहाँ कोई भी महिला स्वास्थ्य समस्या के बारे में
                बात करने में संकोच न करे।
              </p>
            </div>
            <div className="mv-card promise reveal">
              <div className="mv-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M20 6L23.5 13.5L32 14.5L26 20.5L27.5 29L20 25L12.5 29L14 20.5L8 14.5L16.5 13.5L20 6Z" stroke="#1a2e4a" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>हमारा वादा</h3>
              <p>
                आपकी गोपनीयता, आपका भरोसा और आपका स्वास्थ्य — यही हमारी प्राथमिकता है।
                हम सिर्फ उत्पाद नहीं बेचते, हम एक साथी की तरह आपके साथ खड़े हैं।
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── MILESTONES ── */}
      <section className="milestones-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '52px' }}>
            <span className="section-label">हमारा सफर</span>
            <h2 className="section-title">अब तक की यात्रा</h2>
          </div>
          <div className="milestones-track">
            <div className="milestones-line"/>
            {milestones.map((m, i) => (
              <div className="milestone-item reveal" key={i} style={{ animationDelay: `${i * 0.12}s` }}>
                <div className="milestone-dot">
                  <span>{m.icon}</span>
                </div>
                <div className="milestone-body">
                  <strong>{m.year}</strong>
                  <p>{m.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FOUNDERS ── */}
      <section className="founders-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">Team</span>
            <h2 className="section-title">वो जिन्होंने यह सपना देखा</h2>
          </div>
          <div className="founders-grid">
            {team.map((t, i) => (
              <div className="founder-card reveal" key={i} style={{ animationDelay: `${i * 0.15}s` }}>
                <div className="founder-avatar" style={{ background: `${t.color}22`, border: `2px solid ${t.color}` }}>
                  <span style={{ color: t.color }}>{t.avatar}</span>
                  <div className="founder-avatar-ring" style={{ borderColor: t.color }}/>
                </div>
                <div className="founder-info">
                  <h3>{t.name}</h3>
                  <span className="founder-role">{t.role}</span>
                  <p>{t.story}</p>
                </div>
                <div className="founder-quote-mark" style={{ color: t.color }}>"</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section className="values-section">
        <div className="container">
          <div className="section-header reveal" style={{ textAlign: 'center', marginBottom: '48px' }}>
            <span className="section-label">हमारे मूल्य</span>
            <h2 className="section-title">जिन सिद्धांतों पर हम चलते हैं</h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div className="value-card reveal" key={v.title} style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="value-icon-wrap">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section className="about-contact-section">
        <div className="container">
          <div className="about-contact-inner">
            <div className="about-contact-text reveal">
              <span className="section-label" style={{ background: 'rgba(201,150,58,0.15)', color: '#e8b96a', borderColor: 'rgba(201,150,58,0.3)' }}>संपर्क करें</span>
              <h2 style={{ color: 'white', marginTop: '12px' }}>हम आपकी बात सुनना चाहते हैं</h2>
              <p style={{ color: 'rgba(255,255,255,0.7)', marginTop: '12px', lineHeight: '1.8' }}>
                कोई सवाल हो, सुझाव हो, या बस बात करनी हो — हम हमेशा उपलब्ध हैं।
                आपकी हर बात गोपनीय रहेगी।
              </p>
            </div>
            <div className="about-contact-cards reveal">
              <a href={`tel:${PHONE}`} className="contact-card">
                <div className="contact-card-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                </div>
                <div>
                  <strong>Call करें</strong>
                  <span>{PHONE}</span>
                </div>
              </a>
              <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} target="_blank" rel="noreferrer" className="contact-card whatsapp">
                <div className="contact-card-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </div>
                <div>
                  <strong>WhatsApp करें</strong>
                  <span>तुरंत जवाब पाएं</span>
                </div>
              </a>
              <a href={`mailto:${EMAIL}`} className="contact-card">
                <div className="contact-card-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div>
                  <strong>Email करें</strong>
                  <span>{EMAIL}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}